<template>
<v-speed-dial absolute v-model="fab" :top="true" :bottom="false" :right="false" :left="true" :direction="'bottom'" :open-on-hover="true" :transition="'slide-y-transition'">
    <template v-slot:activator>
        <v-btn v-model="fab" color="blue-grey darken-3" dark fab :class="isIndex">
            <router-link to="/">
                <v-avatar>
                    <img src="@/assets/ganeshur_avatar_40.jpg"/>
                </v-avatar>
            </router-link>
        </v-btn>
    </template>
    <v-btn v-for="menuItem in menuItems" fab dark small :color="menuItem.color" :key="menuItem.icon">
        <v-tooltip right color="black">
            <template v-slot:activator="{on, attrs}">
                <router-link :to="menuItem.path">
                    <v-icon v-on="on" v-bind="attrs" :class="menuItem.iconClass">{{ menuItem.icon }}</v-icon>
                </router-link>
            </template>
            <span>{{ menuItem.label }}</span>
        </v-tooltip>
    </v-btn>
    
</v-speed-dial>
</template>

<script>
export default {
    name: 'FabMenu',

    data: () => ({
        fab: false,
        menuItems: [
            { icon:'fas fa-id-card', iconClass:'indigo--text text--darken-2', label:'Curriculum vitae', color:'black', path:'/cv/' },
            { icon:'fas fa-file-code', iconClass:'grey--text text--lighten-1', label:'Astuces de codeur', color:'black', path:'/astuces/' },
            { icon:'fas fa-globe-americas', iconClass:'blue--text text--darken-3', label:'Voyages', color:'black', path:'/voyages/' },
            { icon:'far fa-images', iconClass:'teal--text text--darken-2', label:'Albums photos', color:'black', path:'/photos/' },
            { icon:'fab fa-fort-awesome', iconClass:'deep-orange--text text--darken-3', label:'Le royaume d\'Andoras', color:'black', path:'/andoras/' },
        ],
    }),
    computed: {
        // on applique l'effet bounce sur le FabButton que si on est sur la Home
        isIndex: function() {
            return this.$route.name=='Home' ? 'bounce' : ''
        }
    }
}
</script>
<style scoped>
.bounce {
    -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1) !important;
    -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1) !important;
    -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1) !important;
    animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1) !important;
    transition: all 300ms ease-in-out !important;
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>